import Control from "../../Control";
import Delegate from "../../Delegate";
import NP, {EventArgs, EventKeyArgs} from "../../NP";
import './Label.css';

let S = require('string');

export default class Label extends Control {
	private _EnableEdit: boolean;
	private _Edit: boolean;
	private _MultiLine: boolean;
	private _TextWrap: boolean;
	public EvEditing: Delegate;
	public EvEdited: Delegate;
	public EvEditingEnd: Delegate;
	private _contentNode: HTMLElement;
	private _textArea: HTMLInputElement;

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._EnableEdit = false;
		this._Edit = false;
		this._MultiLine = false;
		this._TextWrap = true;

		this.EvEditing = new Delegate();
		this.EvEdited = new Delegate();
		this.EvEditingEnd = new Delegate();
		super._initFields(settings);
	}

	getEnableEdit()
	{
		return this._EnableEdit;
	}

	getEdit()
	{
		return this._Edit;
	}

	getMultiLine()
	{
		return this._MultiLine;
	}

	getTextWrap()
	{
		return this._TextWrap;
	}

	_render()
	{
		this.np_render(`<div tabIndex='0' class='label ${this._TextWrap ? "wrap" : "nowrap"}'></div>`, true);
		this.setEnableEdit(this._EnableEdit, true);
	}

	_onKeyUp()
	{
		this._updateEditSize();
	}

	_bindEvents()
	{
		if (!this._isBind)
		{
			super._bindEvents();
			this._addEvent(this._root, "input", this._onKeyUp);
		}
	}

	_unBindEvents()
	{
		this._removeAllEvents(this._root);
		super._unBindEvents();
	}

	_updateEditSize()
	{
		if (this._Edit)
		{
			NP.showNode(this._contentNode);
			this._contentNode.innerHTML = this._textArea.value ? S(this._textArea.value).escapeHTML().s + '&nbsp;' : '&nbsp;';
			this._textArea.style.width = this._contentNode.offsetWidth + 'px';
			this._textArea.style.height = this._contentNode.offsetHeight + 'px';
			NP.hideNode(this._contentNode);
		}
	}

	_selectAll()
	{
		if (this._textArea.setSelectionRange)
		{
			this._textArea.focus();
			this._textArea.setSelectionRange(0, this._textArea.value.length);
		}
		else if ((<any>this._textArea).createTextRange)
		{
			let range = (<any>this._textArea).createTextRange();
			range.collapse(true);
			range.moveEnd('character', this._textArea.value.length);
			range.moveStart('character', 0);
			range.select();
		}
	}

	_onDblClick(sender: Control, args: EventKeyArgs)
	{
		this.setEdit(true);
		return super._onDblClick(sender, args);
	}

	_onBlur()
	{
		this.setEdit(false);
	}

	_onTextAreaKeyDown(sender: Control, args: EventKeyArgs)
	{
		args.Event.stopPropagation();
		switch (args.Event.keyCode)
		{
			case NP.Key.Esc:
				this.setEdit(false, true);
				break;
			case NP.Key.Enter:
				if (NP.isCtrlKey(args.Event) || !this._TextWrap)
					this.setEdit(false);
				break;
		}
	}


	_onContextMenu(sender: Control, args: EventArgs)
	{
		if (this._Edit)
		{
			this._showContextMenu(sender, args);
			args.Event.stopPropagation();
		}
		else
			return super._onContextMenu(sender, args);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		if (this._contentNode)
			this._contentNode.style.width = value + 'px';
		if (this._textArea)
			this._textArea.style.width = value + 'px';
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		if (this._contentNode)
			this._contentNode.style.height = value + 'px';
		if (this._textArea)
			this._textArea.style.height = value + 'px';
	}

	setContent(content: string)
	{
		if (NP.isString(content) && !this._MultiLine)
			content = content.replace(/\r|\n/g, '');
		if (this._contentNode)
			this._setContentToNode('', this._contentNode, "Content", true);
		this._setContentToNode('', this._root, "Content", true);
		let contentNode = (this._EnableEdit || NP.isString(content)) && this._contentNode ? this._contentNode : this._root;
		this._setContentToNode(content, contentNode, "Content", true);
		if (contentNode != this._root && !contentNode.parentNode)
			this._root.appendChild(contentNode);
	}

	setEnableEdit(value: boolean, _reInit?: boolean)
	{
		if (value !== this._EnableEdit || _reInit)
		{
			this._EnableEdit = value;
			this.addClass("view");
			if (!this._EnableEdit && !NP.isString(this._Content))
			{
				this.setEdit(false);
				this._setContentToNode(this._Content || NP.RM.getString(this._RK), this._root, 'Content', true);
			}
			else
			{
				let content = this._Content || NP.RM.getString(this._RK);
				this._contentNode = NP.parseHTML('<div class="lbl-cnt"></div>');
				this._setContentToNode(content, this._contentNode, 'Content', true);
				this._setContentToNode(this._contentNode, this._root, 'Content', true);
				this.setContent(content);
			}
		}
	}

	setEdit(value: boolean, cancel?: boolean)
	{
		if (!this._EnableEdit || !this._Enabled)
			value = false;
		if (value !== this._Edit)
		{
			if (value)
			{
				let args = {Cancel: false};
				this.EvEditing.fire(this, args);
				if (args.Cancel)
					return;
			}
			this._Edit = value;

			if (this._Edit)
			{
				this.removeClass("view");
				if (this._textArea)
					this._removeAllEvents(this._textArea);
				this._textArea = this._textArea || NP.createNode(null, 'lbl-edit-area', 'textarea');
				this._textArea.value = this._contentNode.textContent || this._contentNode.innerText;
				this._addEvent(this._textArea, 'keydown', this._onTextAreaKeyDown);
				NP.hideNode(this._contentNode);
				this._root.appendChild(this._textArea);
				this._updateEditSize();
				this._selectAll();
				this._addEvent(this._textArea, "blur", this._onBlur);
			}
			else
			{
				this.addClass("view");
				let isContentChanged;
				if (!cancel)
				{
					let content = S((this._textArea.value || '').trim()).escapeHTML().s;
					if (content == '')
						content = '&nbsp;';
					isContentChanged = content !== this._Content;
					this.setContent(content);
				}
				else
				{
					this.setContent(this._Content);
					isContentChanged = (this._contentNode ? this._contentNode : this._root).innerHTML !== this._Content;
				}
				if (this._textArea.parentNode)
					this._textArea.parentNode.removeChild(this._textArea);
				NP.showNode(this._contentNode);
				this._removeAllEvents(this._textArea);
				if (isContentChanged)
					this.EvEdited.fire(this);
				this.EvEditingEnd.fire(this);
			}
		}
	}

	setMultiLine(value: boolean)
	{
		this._MultiLine = value;
		this.setContent(this._Content);
	}

	setTextWrap(value: boolean)
	{
		this._TextWrap = value;
		this.addClass(this._TextWrap ? "wrap" : "nowrap");
		this.removeClass(this._TextWrap ? "nowrap" : "wrap");
	}

	refreshFont()
	{
		super.refreshFont();
		this._root.style.lineHeight = ((this._Font.getLineHeight() || 1) * (NP.Font.defaultLineHeights[this._Font.getFontFamily()] || 1.2)) + '';
	}

};


NP.Label = Label;